import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import FotEdit from '../images/fotedit.png';
import Schiphol from '../images/schiphol.png';
import Stock from '../images/simplestockview.png';
import Rick from '../images/ricktacmorty.png';

export default function Portfolio() {
    const [opacityFot, setOpacityFot] = useState("40%");
    const [opacitySchiphol, setOpacitySchiphol] = useState("40%");
    const [opacityStock, setOpacityStock] = useState("40%");
    const [opacityRick, setOpacityRick] = useState("40%");
    const [displayWidth, setDisplayWidth] = useState(()=>getWidth());
    const [direction,setDirection] = useState(()=>getDirection());

    const style = {
        paragraph: {
            fontSize: "18px",
            textAlign: "left"
        },
        aboutdiv: {
            margin: "0 auto",
            width: "75%",
            border: "1px solid black",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "20px"
        },
        overall: {
            backgroundColor: "#0b486b",
            height: "auto",
            minHeight: "80vh",
            padding: "50px 0"
        },
        link: {
            textDecoration: "none"
        },
        title: {
            fontSize: "32px",
            margin: "4px",
            textAlign: "center"
        },
        linkdiv: {
            width: "30%",
            margin: "0 auto"
        },
        linkspan: {
            textDecoration: "none",
            color: "black"
        },
        text: {
            display: "inline-block",
            marginLeft: "5px"
        },
        projectdiv: {
            width: displayWidth,
            border: "1px dotted lightgrey",
            padding: "10px",
            borderRadius: "5px",
            margin: "2.5%"
        },
        topdiv: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        projectcontainer: {
            display: "flex",
            flexDirection: direction,
            width: "95%",
            display: "flex",
            alignItems: "center"
        },
        projectimgfotedit: {
            display: "block",
            width: "90%",
            opacity: opacityFot,
            margin: "0 auto"
        },
        projectimgschiphol: {
            display: "block",
            width: "90%",
            opacity: opacitySchiphol,
            margin: "0 auto"
        },
        projectimgstock: {
            display: "block",
            width: "90%",
            opacity: opacityStock,
            margin: "0 auto"
        },
        projectimgrick: {
            display: "block",
            width: "90%",
            opacity: opacityRick,
            margin: "0 auto"
        },
        tech: {
            fontSize: "12px",
            fontStyle: "italic"
        },
        projecttitle: {
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "center",
            margin: "3px"
        },
        imgdiv: {
            width: "100%"
        }
    }


    function getWidth(){
        return window.innerWidth<800? "95%":"45%";
    }

    function getDirection(){
        return window.innerWidth<800? "column":"row";
    }

    function windowSize (){
        if (window.innerWidth<800){
            setDisplayWidth("95%");
            setDirection("column")
        } else {
            setDisplayWidth("45%");
            setDirection("row")
        }
    }

    window.addEventListener('resize', windowSize)

    function opacitySet(e) {
        let temp = e.target.getAttribute("name");
        console.log(temp);
        switch (temp) {
            case "fotedit": setOpacityFot("100%");
                break;
            case "schiphol": setOpacitySchiphol("100%");
                break;
            case "rick": setOpacityRick("100%");
                break;
            case "stock": setOpacityStock("100%");
                break;
            default: break;
        }
    }

    function opactiyReset(e) {
        let temp = e.target.getAttribute("name")
        switch (temp) {
            case "fotedit": setOpacityFot("40%");
                break;
            case "schiphol": setOpacitySchiphol("40%");
                break;
            case "rick": setOpacityRick("40%");
                break;
            case "stock": setOpacityStock("40%");
                break;
            default: break;
        }
    }

    return (
        <div style={style.overall}>
            <div style={style.aboutdiv}>
                <h2 style={style.title}>Projects</h2>
                <div style={style.topdiv}>
                    <div style={style.projectcontainer}>
                        <div style={style.projectdiv}>
                            <p style={style.projecttitle}>FotEdit</p>
                            <div style={style.imgdiv}>
                                <a href='https://fotedit.surge.sh/' target="_blank">
                                    <img src={FotEdit} alt="FotEdit" style={style.projectimgfotedit} onMouseOver={opacitySet} onMouseLeave={opactiyReset} name="fotedit" />
                                </a>
                            </div>
                            <p>FotEdit is a web-based photo editor. It allows users to share photo galleries and have others edit their photos and share the edits.</p>
                            <p style={style.tech}>Technologies used: ReactJS front-end, Ruby on Rails with AWS S3 back-end</p>
                        </div>
                        <div style={style.projectdiv}>
                            <p style={style.projecttitle}>Schiphol Navigator</p>
                            <div style={style.imgdiv}>
                                <a href="https://schiphol-nav.surge.sh/" target="_blank">
                                    <img src={Schiphol} alt="Schiphol Navigator" style={style.projectimgschiphol} name="schiphol" onMouseOver={opacitySet} onMouseLeave={opactiyReset} />
                                </a>
                            </div>
                            <p>Schiphol Navigator is a web application that gives users up to the minute flight information at Amsterdam Schiphol Airport.</p>
                            <p style={style.tech}>Technologies used: ReactJS</p>
                        </div>
                    </div>
                    <div style={style.projectcontainer}>
                        <div style={style.projectdiv}>
                            <p style={style.projecttitle}>SimpleStock View</p>
                            <div style={style.imgdiv}>
                                <a href="http://simplestockview.surge.sh/" target="_blank">
                                    <img src={Stock} alt="SimpleStock View" style={style.projectimgstock} name="stock" onMouseOver={opacitySet} onMouseLeave={opactiyReset} />
                                </a>
                            </div>
                            <p>Simple Stock View is a web application that allows users to search for stock tickers and save their favorites.</p>
                            <p style={style.tech}>Technologies used: Javascript</p>
                        </div>
                        <div style={style.projectdiv}>
                            <p style={style.projecttitle}>Rick Tac Morty</p>
                            <div style={style.imgdiv}>
                                <a href="http://mikeip.com/projects/rictacmorty/" target="_blank">
                                    <img src={Rick} alt="Rick Tac Morty" style={style.projectimgrick} name="rick" onMouseOver={opacitySet} onMouseLeave={opactiyReset} />
                                </a>
                            </div>
                            <p>A javascript-based Tic-tac-toe game with a Rick and Morty theme.</p>
                            <p style={style.tech}>Technologies used: Javascript</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}